import { Component, OnInit } from '@angular/core';
import {PageService} from "../shared/layout/services/page.service";

@Component({
  selector: 'app-trilha-auditoria',
  templateUrl: './trilha-auditoria.component.html',
  styleUrls: ['./trilha-auditoria.component.scss']
})
export class TrilhaAuditoriaComponent implements OnInit {

  constructor(private page: PageService) {
  }


  ngOnInit() {
    this.page.defineTitle('TRILHA DE AUDITORIA');
  }


}
